let _isOpen = null;

function init(isExperimentOpen) {
    _isOpen = _isOpen || isExperimentOpen;
}

function isOpen(...args) {
    return !!_isOpen && _isOpen(...args);
}

export default {
    init,
    isOpen
};
